import * as React from 'react';
import PropTypes from 'prop-types';

const SvgActionsVisibleDisabledNormalXsmall = React.forwardRef(
  ({ color, size, ...props }, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      fill={color}
      width={size}
      height={size}
      {...props}
    >
      <path d="M15.89 8.45a1 1 0 000-.89C14.05 3.87 11.4 2 8 2a7.65 7.65 0 00-4.12 1.17L2.36 1.65a.5.5 0 00-.71.71l12 12a.5.5 0 10.71-.71l-1.4-1.4a11.15 11.15 0 002.93-3.8zM9.72 9L7 6.28A2 2 0 018 6a2 2 0 012 2 2 2 0 01-.28 1zm2.53 2.53l-1.82-1.81A2.94 2.94 0 0011 8a3 3 0 00-3-3 2.94 2.94 0 00-1.72.57L4.59 3.88A6.75 6.75 0 018 3c4 0 6 3 7 5a10.31 10.31 0 01-2.75 3.54zM8 13c-4 0-6-3-7-5a11.25 11.25 0 012-2.89l-.7-.7A12.18 12.18 0 00.11 7.55a1 1 0 000 .89C1.95 12.13 4.6 14 8 14a7.87 7.87 0 003.22-.67l-.76-.76A6.94 6.94 0 018 13z" />
      <path d="M8.78 10.88l-.9-.9A2 2 0 016 8.11l-.9-.9A3 3 0 005 8a3 3 0 003 3 3 3 0 00.78-.12z" />
    </svg>
  )
);
SvgActionsVisibleDisabledNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16
};
SvgActionsVisibleDisabledNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number
};
export default SvgActionsVisibleDisabledNormalXsmall;
